__turbopack_context__.v({
  "copyLabel": "wPiE-G_copyLabel",
  "copyText": "wPiE-G_copyText",
  "copyTextButton": "wPiE-G_copyTextButton",
  "copyWrapper": "wPiE-G_copyWrapper",
});
